import { useEffect } from 'react';
import appBranding from '@happylife-a/branding';
import { fieldTrackings } from './tracking';

function loadScript() {
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
}

export default function MetaPixelScript({ appType }) {
  const metaPixelId = appBranding.configs.environments.getField(fieldTrackings[appType].MetaPixel);

  useEffect(() => {
    if (!metaPixelId || typeof window === 'undefined') {
      return;
    }

    // Load the Pixel script only if it's not already loaded
    if (!window.fbq) {
      loadScript();
    }

    // Initialize Facebook Pixel
    window.fbq('init', metaPixelId);
    window.fbq('track', 'PageView');
  }, [metaPixelId]);

  if (!metaPixelId) {
    return null;
  }

  return null;
}
